export default function getFlagName(language) {
  switch (language) {
    case "dutch":
      return "NL";
      break;
    case "english":
      return "GB";
      break;
    case "german":
      return "DE";
      break;
    case "chinese":
      return "CN";
      break;
    case "italian":
      return "IT";
      break;
    case "french":
      return "FR";
      break;
    case "spanish":
      return "ES";
      break;
    default:
      return "NL";
      break;
  }
}
